<mat-dialog-content class="image-preview-dialog-container">
  <button mat-icon-button 
          aria-label="Close" 
          (click)="onClose()" 
          class="close-button">
    <mat-icon>close</mat-icon>
  </button>
  
  <ng-container *ngIf="data.imageUrl | imageUrl as secureUrl; else loading">
    <img [src]="secureUrl" alt="Preview" class="preview-img" />
  </ng-container>
  <ng-template #loading>
    <div class="img-loading-icon">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  </ng-template>
</mat-dialog-content>
